import { render } from "./TopDeck.vue?vue&type=template&id=d548c86e&scoped=true"
import script from "./TopDeck.vue?vue&type=script&lang=js"
export * from "./TopDeck.vue?vue&type=script&lang=js"

import "./TopDeck.vue?vue&type=style&index=0&id=d548c86e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d548c86e"]])

export default __exports__